export const VISIBILITY = "Visibility";
export const VISIBILITY_OFF = "VisibilityOff";
export const PROFILE_ICON = "AccountCircle";

export const DECIMAL_COUNT = 2;
